import omit from 'lodash/omit';
import { parseConfig } from '../../../shared/config';
import { channelFromUrl } from '../../../shared/model/constants/channels';
import { getTenureTypeByKey } from '../../../shared/model/constants/tenureType';
import { getPropertyTypeFromDisplayText } from '../../../shared/model/constants/propertyTypes';
import bffRequest from '../../../shared/requests/bffRequest';

const mapAvailableChannelObjects = (availableChannels = []) => (
  availableChannels.map(channel => channelFromUrl(channel))
);

export async function getListingDetails(
  listingId,
  channelObject,
  featureFlags,
) {
  const response = await bffRequest({
    path: `listings/${listingId}`,
    method: 'GET',
    query: {
      channel: channelObject?.url,
      featureFlags,
    },
  });
  const { listing } = response;

  return {
    ...response,
    listing: {
      ...omit(listing, ['availableChannels', 'tenureType', 'propertyTypes']),
      availableChannelObjects: mapAvailableChannelObjects(listing.availableChannels),
      tenureTypeObject: getTenureTypeByKey(listing.tenureType),
      propertyTypeObjects: listing.propertyTypes.map(getPropertyTypeFromDisplayText),
      similarListings: listing?.similarListings?.map(similarListing => ({
        propertyTypeObjects: similarListing?.propertyTypes?.map(getPropertyTypeFromDisplayText),
        ...omit(similarListing, ['propertyTypes']),
      })),
    },
  };
}

export async function getDetailUrl(listingId) {
  const { WEBSITE_ROOT } = parseConfig();

  const { detailUrl } = await bffRequest({
    path: `detail-url/${listingId}`,
    method: 'GET',
  });
  const { pathname } = new URL(`${WEBSITE_ROOT}${detailUrl}`);

  return pathname;
}
